<template>
  <div>
    <Breadcrumb :style="{ margin: '20px 10px' }">
      <BreadcrumbItem>券码管理</BreadcrumbItem>
      <BreadcrumbItem>核销警告</BreadcrumbItem>
    </Breadcrumb>
    <loading :loading="loading" :error="error"></loading>
    <!-- 查询表单 -->
    <Form ref="selectForm" :model="selectForm" inline style="margin: 10px 0;">
      <FormItem prop="use_time">
        <DatePicker 
          type="datetime" 
          placeholder="请选择核销时间范围" 
          style="width: 200px" 
          v-model="selectForm.use_time_raw" 
          format="yyyy-MM-dd HH:mm:ss" 
          :value="selectForm.use_time_raw"
          @on-change="handleDateChange"
        />
      </FormItem>
       
       
      <FormItem prop="num">
        <Input v-model="selectForm.num" placeholder="核销数量"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit">查询</Button>
        <Button style="margin-left: 10px;" @click="resetForm">重置</Button>
      </FormItem>
    </Form>
    
    <!-- 表格展示（仅在加载完成且无错误时显示） -->
    <Table 
      border 
      stripe 
      :columns="columns1" 
      :data="orders" 
      v-if="!loading && !error && orders.length > 0"
      style="width: 100%; margin: 10px 0;"
    >
    </Table>
    
    <!-- 空数据提示 -->
    <div v-if="!loading && !error && orders.length === 0" style="text-align: center; padding: 50px 0; color: #999;">
      暂无符合条件的数据
    </div>
    
    <expandRow style="display: none"></expandRow>
    
    <Page 
      style="margin: 10px; text-align:center;" 
      @on-change="pageOnChange" 
      :total="pages.total" 
      :page-size="pages.per_page" 
      :current="pages.current_page"
      show-elevator 
      prev-text="上一页" 
      next-text="下一页" 
      v-if="!loading && !error && pages.total > 0"
    />
  </div>
</template>

<script>
import expandRow from '../member-1/coupon_expand.vue';
import loading from '../loading.vue';
export default {
  components: { expandRow, loading },
  data () {
    return {
      modelSwitch: false,
      loading: false,
      error: null,
      orders: [], 
      pages: {
        total: 0,         
        per_page: 10,    
        current_page: 1,  
        last_page: 1     
      },
      selectForm: {
        use_time_raw: '', 
        use_time: '',     
        num: ''           
      },
      companies: [],
      ruleInline: {},
      selectedOrder: {
        id: 0
      },
      columns1: [
        { 
          align: "center", 
          title: '手机号码', 
          key: 'business_id', 
          minWidth: 120 
        },
        { 
          align: "center", 
          title: '核销数量', 
          key: 'coupons_in_next_hour', 
          width: 150 
        },
        { 
          align: "center", 
          title: '核销时间', 
          key: 'use_time', 
          minWidth: 180 
        }
      ],
      showAfterRenderClass: false
    }
  },
  created () {
    if ('doudian_open_id' in this.$route.query) {
      this.selectForm.doudian_open_id = this.$route.query.doudian_open_id;
    }
    this.fetchData('useWarn', this.selectForm);
  },
  methods: {
    // 处理日期选择变化
    handleDateChange(date) {
      if (date) {
        this.selectForm.use_time_raw = date;
        // 同时更新格式化后的时间
        this.selectForm.use_time = this.formatToLocalString(date);
      } else {
        this.selectForm.use_time_raw = '';
        this.selectForm.use_time = '';
      }
    },
    
    // 格式化时间为本地字符串
    formatToLocalString(dateString) {
      if (!dateString) return '';
      
      const date = new Date(dateString);
      
      if (isNaN(date.getTime())) {
        return '';
      }
      
      // 格式化为 yyyy-MM-dd HH:mm:ss
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    statusIdChanged (val) {
      console.log('statusIdChanged val=>', val);
      this.selectForm.status_id = val;
    },
    dateOnChange (date) {
      console.log(date);
      this.selectForm.start_date = date[0];
      this.selectForm.end_date = date[1];
    },
    
    // 重置表单
    resetForm() {
      this.selectForm = {
        use_time_raw: '',
        use_time: '',
        num: ''
      };
      this.fetchData('useWarn', this.selectForm);
    },
    
    // 处理提交
    handleSubmit() {
      if (this.selectForm.use_time_raw) {
        this.selectForm.use_time = this.formatToLocalString(this.selectForm.use_time_raw);
      }
      
      const submitData = {
        ...this.selectForm
      };
      
      delete submitData.use_time_raw;
      
      console.log('提交的数据：', submitData);
      
      this.fetchData('useWarn', submitData);
    },
    
    // 处理分页
    handlePageSubmit(page) {
      const submitData = {
        ...this.selectForm
      };
      
      if (submitData.use_time_raw) {
        submitData.use_time = this.formatToLocalString(submitData.use_time_raw);
      }
      
      delete submitData.use_time_raw;
      
      submitData.page = page;
      
      console.log('分页提交的数据：', submitData);
      
      this.fetchData('useWarn', submitData);
    },
    
    // 分页切换
    pageOnChange(page) {
      this.handlePageSubmit(page);
    },
    
    fetchData(url, param) {
      this.loading = true;
      this.error = null;
      this.orders = []; 

      const requestParams = { ...param };
      Object.keys(requestParams).forEach(key => {
        if (requestParams[key] === undefined || requestParams[key] === '' || requestParams[key].length === 0) {
          delete requestParams[key];
        }
      });

      console.log('发送的请求参数：', requestParams);
      
      this.axios.get(url, {
        params: requestParams 
      }).then(res => {
        console.log('接口返回完整数据：', res);
        if (res.data && res.data.list) {
          this.orders = res.data.list;
          this.pages = {
            total: res.data.meta.total || 0,        
            per_page: res.data.meta.per_page || 10,  
            current_page: res.data.meta.current_page || 1, 
            last_page: res.data.meta.last_page || 1  
          };
        } else {
          this.orders = [];
          this.pages = { total: 0, per_page: 10, current_page: 1, last_page: 1 };
        }
        this.loading = false; // 关闭加载
      }).catch(err => {
        console.error('接口请求失败：', err);
        this.loading = false;
        this.error = '数据加载失败，请刷新重试！';
        if (this.$Message) {
          this.$Message.error(this.error);
        }
      });
    }
  }
}
</script>

<style scoped>
/deep/ .ivu-table {
  margin: 10px 0;
}
/deep/ .ivu-page {
  margin-top: 20px;
}
.empty-tip {
  text-align: center;
  padding: 50px 0;
  color: #999;
}
</style>